import React, { useEffect, useState } from 'react';
import PieChart, {
    Legend,
    Series,
    Tooltip,
    Format,
    Label,
    Connector,
    Export,
} from 'devextreme-react/pie-chart';
import CardQuick from '../../components/Card';
import { Box, Button, Typography } from '@mui/material';
import { dashboardService } from "../../services";
import { useNavigate } from 'react-router-dom';


const ActsStatsDoghnout = ({locationId}) => {
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false)

    useEffect(() => {
        dashboardService.getActsStats(locationId).then((data) => {
            setData(data);
            setShow(true)
        }).catch(() => {
            setShow(false)

        })
    }, [locationId])

    const TooltipTemplate = (pieChart) => {
        const formatNumber = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
        }).format;

        function calculateTotal(pieChart) {
            return formatNumber(pieChart
                .getAllSeries()[0]
                .getVisiblePoints()
                .reduce((s, p) => s + p.originalValue, 0));
        }
        return (
            <svg>
                <circle cx="100" cy="100" r={pieChart.getInnerRadius() - 6} fill="#FFF"></circle>
                <text textAnchor="middle" x="100" y="120" style={{ fontSize: 18, fill: '#494949' }}>
                    <tspan x="100" dy="-10px" style={{ fontWeight: 600,fontSize: 30 }}>{
                        calculateTotal(pieChart)
                    }</tspan>
                </text>
            </svg>
        );
    }

    return (
        <Box>
            <CardQuick>
                <Typography variant="h3">Actos</Typography>
                {show ?
                    <PieChart
                        id="pie"
                        type="doughnut"
                        palette="Soft Pastel"
                        dataSource={data}
                        style={{ height: '300px' }}
                        centerRender={TooltipTemplate}


                    >
                        <Series
                            valueField="total"
                            argumentField="name">
                            <Label visible={true} format="decimal">
                                <Connector visible={true} />
                            </Label>
                        </Series>
                        <Legend
                            margin={0}
                            horizontalAlignment="right"
                            verticalAlignment="top"
                        />
                        <Tooltip enabled={true}>
                            <Format type="fixedPoint" />
                        </Tooltip>
                    </PieChart>
                    :
                    null
                }

            </CardQuick>
            <Box sx={{ borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }} bgcolor={'#ececec'}>
                <Button onClick={() => {
                    navigate('schedules?voucher=1');

                }} sx={{ margin: '8px' }} variant="contained" color="secondary2">Ver Actos</Button>

            </Box>
        </Box>


    )

}
export default ActsStatsDoghnout;